<template>
  <div class="background">
    <article class="leaderboard">
      <header>
        <h1 class="leaderboard__title"><span class="leaderboard__title--top">今日完成</span>
          <span class="leaderboard__title--bottom">{{this.today}}，感谢你今天作出的努力</span></h1>
      </header>

      <div class="leaderboard__profiles">
        <article class="leaderboard__profile" v-for="item in workList" :key="item.title">
          <span class="leaderboard__name">{{ item.title }}</span>
          <span :class="'leaderboard__value '+ item.color">{{item.periodFormat}}</span>
          <span class="leaderboard__value_gift" @click="getGift(item)">{{item.gift ? "" : "领取奖励"}}</span>
        </article>
        <article class="leaderboard__profile">
          <span class="leaderboard__name" @click="txg()">天心阁</span>
        </article>
      </div>
    </article>
  </div>
</template>

<script>

  export default {
    name: 'WorkDetail',
    data () {
      return {
        baseUrl: "http://goc6.com",
        //'http://localhost:8077',
        fromTime: new Date(new Date().toLocaleDateString()).getTime(),
        today: "",
        score : 100,
        workList : []
      }
    },
    mounted () {
      let fromDate = new Date();
      this.today = fromDate.getFullYear()+"-"+(fromDate.getMonth()+1)+"-"+fromDate.getDate();
      this.inits();
    },
    methods: {
      inits () {
        let fromTime = this.fromTime;
        let toTime = fromTime+24*3600*1000;
        const url = this.baseUrl + "/front/time/listDetail?startTime="+fromTime+"&endTime="+toTime+"&player="+localStorage.getItem("player");
        let that = this;
        this.$axios.get(url, {
        }).then(function (response) {
          that.workList = response.data || [];
        })
      },
      getGift (item) {
        console.log(item);
        const that = this;
        const url = this.baseUrl + "/front/time/gift";
        this.$axios.post(url, {
          id: item.id,
          player: localStorage.getItem("player")
        }).then(function (response) {
          if(response.data=='success') {
            that.inits ();
          }
        });
      },
      txg () {
        window.location.href="/gift";
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  html, body { height: 100%; width: 100%;Font-size: 25%}
  body {
    margin: 0;
    background-color: #eaeaea;
    display: grid;
    height: 100vh;
    place-items: center;
    font-family: 'Source Sans Pro', sans-serif;
  }
  .background{
    /*background-image: url("https://t7.baidu.com/it/u=1297102096,3476971300&fm=193&f=GIF");*/
    height: 100%;
    width: 100%;
    background-size: cover;
    position: absolute;
  }
  .leaderboard {
    position: absolute;
    width: 90%;
    top: 5%;
    left: 5%;
    max-width: 490px;
    border-radius: 12px;
  }
  .leaderboard header {
    --start: 15%;
    height: 130px;
    background-image: repeating-radial-gradient(circle at var(--start), transparent 0%, transparent 10%, rgba(54, 89, 219, 0.33) 10%, rgba(54, 89, 219, 0.33) 17%), linear-gradient(to right, #5b7cfa, #3659db);
    color: #fff;
    position: relative;
    border-radius: 12px 12px 0 0;
    overflow: hidden;
  }
  .leaderboard header .leaderboard__title {
    position: absolute;
    z-index: 2;
    top: 50%;
    right: calc(var(--start) * .75);
    transform: translateY(-50%);
    text-transform: uppercase;
    margin: 0;
  }
  .leaderboard header .leaderboard__title span {
    display: block;
  }
  .leaderboard header .leaderboard__title--top {
    font-size: 24px;
    font-weight: 700;
    letter-spacing: 6.5px;
  }
  .leaderboard header .leaderboard__title--bottom {
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 3.55px;
    opacity: .65;
    transform: translateY(-2px);
  }
  .leaderboard header .leaderboard__icon {
    fill: #fff;
    opacity: .35;
    width: 50px;
    position: absolute;
    top: 50%;
    left: var(--start);
    transform: translate(-50%, -50%);
  }
  .leaderboard__profiles {
    background-color: #fff;
    border-radius: 0 0 12px 12px;
    padding: 15px 15px 20px;
    display: grid;
    row-gap: 8px;
  }
  .leaderboard__profile {
    display: grid;
    grid-template-columns: 1fr 3fr 1fr;
    align-items: center;
    padding: 10px 30px 10px 10px;
    overflow: hidden;
    border-radius: 10px;
    box-shadow: 0 5px 7px -1px rgba(51, 51, 51, 0.23);
    cursor: pointer;
    transition: transform 0.25s cubic-bezier(0.7, 0.98, 0.86, 0.98), box-shadow 0.25s cubic-bezier(0.7, 0.98, 0.86, 0.98);
    background-color: #fff;
  }
  .leaderboard__profile:hover {
    transform: scale(1.2);
    box-shadow: 0 9px 47px 11px rgba(51, 51, 51, 0.18);
  }
  .leaderboard__picture {
    max-width: 100%;
    width: 60px;
    border-radius: 50%;
    box-shadow: 0 0 0 10px #ebeef3, 0 0 0 22px #f3f4f6;
  }
  .leaderboard__name {
    width: 100px;
    color: #979cb0;
    font-weight: 600;
    font-size: 20px;
    margin-left: 12px;
  }
  .leaderboard__value {
    /*color: #35d8ac;*/
    font-weight: 700;
    font-size: 20px;
    text-align: right;
  }
  .leaderboard__value_gift {
    /*color: #35d8ac;*/
    font-weight: 500;
    font-size: 10px;
    text-align: right;
  }
  .green {
    color: #72b362;
  }
  .blue {
    color: #7b9ce1;
  }
  .red {
    color: #bd6d6c;
  }
  .leaderboard__value > span {
    opacity: .8;
    font-weight: 600;
    font-size: 20px;
    margin-left: 3px;
  }



  .leaderboard {
    box-shadow: 0 0 40px -10px rgba(0, 0, 0, 0.4);
  }

</style>



// WEBPACK FOOTER //
// src/components/game/WorkDetail.vue